import React, { useContext, useMemo } from 'react';
import { Button, Input } from 'antd';
import { useMobileFactory } from '../../Factory';
import LoginProvider from '../../context';

export default function MobileTab(props: any) {
  const { service, styles } = props;
  const { Mobile, CodeInput, CodeGetter, Form: MobileForm } = useMobileFactory(service);
  const { loading } = useContext(LoginProvider);
  const Validator = useMemo(CodeGetter, [CodeGetter]);
  return (
    <MobileForm>
      <Mobile placeholder="请输入手机号" />
      <div className={styles.captchabox}>
        <Input.Group compact>
          <CodeInput placeholder="请输入验证码" style={{ width: 'calc(100% - 102px)' }} />
          <Validator style={{ height: '100%' }} onClick={() => {}} type="primary" >获取验证码</Validator>
        </Input.Group>
      </div>
      <Button type="primary" htmlType="submit" className={styles.loginbtn} loading={loading}>
        登录
      </Button>
    </MobileForm>
  );
} 